import DiscountIssue from './DiscountIssue'

export default DiscountIssue
